// Where a person was going when sign-in interrupted them. Cognito returns to the
// bare origin, so the console keeps the destination across the round trip (for
// example GitHub sending an installer back to onboarding).
import { session } from "@/lib/storage";

const KEY = "post_signin";

/** Only paths inside the console: never another origin. */
export function safeDestination(raw: unknown): string | null {
  return typeof raw === "string" && raw.startsWith("/") && !raw.startsWith("//") && !raw.includes("\\") ? raw : null;
}

export function rememberDestination(raw: unknown): void {
  const dest = safeDestination(raw);
  if (dest) session.set(KEY, dest);
}

/** The remembered destination, once. */
export function takeDestination(): string | null {
  const dest = safeDestination(session.get(KEY));
  session.remove(KEY);
  return dest;
}
